import { DeliveryPromiseType } from "@omni/types/api/product/bff/shared/enums/deliveryPromiseType.enum";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { CloudDeliveryPromiseType } from "@omni/types/api/product/cloud/shared/enums/deliveryPromiseType.enum";
import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";

import { hasNoStock } from "./productAvailability";

export const getHomeDeliveryKey = (subject: string) => {
    return `${subject}.deliveryPromise.homeDelivery`;
};

export const determineDeliveryTimeTranslationKey = (
    deliveryPromiseType?: CloudDeliveryPromiseType,
    stockLevel?: CloudStockLevel | null,
    realTimeStockAvailable?: boolean,
    realTimeStock?: number,
    isDriveIn?: boolean
): undefined | string => {
    if (deliveryPromiseType === CloudDeliveryPromiseType.AvailableForS2S) {
        return "pdp.deliveryPromise.shipToStore";
    } else if (hasNoStock(realTimeStockAvailable, stockLevel, realTimeStock)) {
        return isDriveIn
            ? "pdp.deliveryPromise.noStock.driveInPickUp"
            : "pdp.deliveryPromise.noStock";
    }

    if (
        deliveryPromiseType === CloudDeliveryPromiseType.OnlyAvailableOffline &&
        realTimeStockAvailable
    ) {
        return "pdp.deliveryPromise.onlyAvailableOffline.realTimeStock";
    }

    if (realTimeStockAvailable) {
        return `pdp.deliveryPromise.${isDriveIn ? "driveInPickUp" : "clickAndCollect"}.realTimeStock`;
    }

    if (deliveryPromiseType === CloudDeliveryPromiseType.OnlyAvailableOffline) {
        return "pdp.deliveryPromise.onlyAvailableOffline";
    }

    if (
        deliveryPromiseType ===
        CloudDeliveryPromiseType.AvailableForPickUpInStore
    ) {
        if (stockLevel === CloudStockLevel.LowStock) {
            return `pdp.deliveryPromise.${isDriveIn ? "driveInPickUp" : "clickAndCollect"}.lowStock`;
        } else {
            return `pdp.deliveryPromise.${isDriveIn ? "driveInPickUp" : "clickAndCollect"}.default`;
        }
    }
};

export const cartDeliveryPromiseTranslationKey = (
    deliveryPromise?: any,
    deliveryType?: DeliveryType
): string => {
    let cartDeliveryPromiseTranslationKey = "cart.deliveryPromise.noStock";

    if (
        deliveryPromise &&
        deliveryPromise.deliveryPromiseType === DeliveryPromiseType.NoStock &&
        deliveryPromise.withRemove
    ) {
        cartDeliveryPromiseTranslationKey =
            "cart.deliveryPromise.noStockAndRemove";
    }

    if (
        deliveryPromise &&
        deliveryPromise.deliveryPromiseType !== DeliveryPromiseType.NoStock
    ) {
        if (deliveryType === DeliveryType.ClickAndCollect) {
            cartDeliveryPromiseTranslationKey =
                "cart.deliveryPromise.clickAndCollect.default";
        } else if (deliveryType === DeliveryType.HomeDelivery) {
            cartDeliveryPromiseTranslationKey = getHomeDeliveryKey("cart");
        }
    }

    return cartDeliveryPromiseTranslationKey;
};
